const CookieLib = {
  getDomain() {
    let domain = '';
    if (window.location.hostname !== 'localhost') {
      domain = `;domain=${window.location.hostname.substring(
        window.location.hostname.indexOf('.'),
      )}`;
    } else {
      domain = `;domain=${window.location.hostname}`;
    }
    return domain;
  },
  isSecure() {
    const envName = process.env.NODE_ENV;
    if (envName === 'production' && window.location.protocol === 'https:') {
      return true;
    }
    return false;
  },
  getCookieByKey(key) {
    let domainPrefix = '';
    domainPrefix = window.location.hostname.substring(
      window.location.hostname.indexOf('.') + 1,
    );
    domainPrefix = domainPrefix.substring(0, domainPrefix.lastIndexOf('.'));
    const name = `${domainPrefix}.${key}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  setCookieByKey(key, value) {
    let domainPrefix = window.location.hostname.substring(
      window.location.hostname.indexOf('.') + 1,
    );
    domainPrefix = domainPrefix.substring(0, domainPrefix.lastIndexOf('.'));
    document.cookie = `${domainPrefix}.${key}=${value};path=/${this.getDomain()}${
      this.isSecure() ? `;secure` : ''
    }`;
  },
  clearAllCookies() {
    // const allCookies = document.cookie;
    // console.log(`Application cookies :  ${allCookies}`);
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${this.getDomain()}${
        this.isSecure() ? `;secure` : ''
      }`;
    }
  },
};

export default CookieLib;
